module.exports = __webpack_public_path__ + "img/drag-n-drop2.8a602b89.svg";